import { PURGE } from "redux-persist";

const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
    loginId : 'NONE',
    name : '',
};

const userSlice = createSlice({
    name : 'user',
    initialState,
    reducers : {
        setUser : (state, action) => {
            state.loginId = action.payload.loginId;
            state.name = action.payload.name;
        },
        deleteUser : (state) => {
            state.loginId = 'NONE';
            state.name = '';
        }
    },
    extraReducers : (builder) => {
        builder.addCase(PURGE, ()=> initialState);
    }
});

export const { setUser, deleteUser } = userSlice.actions;

export default userSlice.reducer;